import React from "react";
import ContentLoader from "../../containers/HomePage/loader";
import loadable from "@loadable/component";

export default loadable(() => import(/* webpackChunkName: 'PopUp' */ "../PopUp"), {
    fallback: <ContentLoader />,
});
